module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-painless-time-tracking@2x-6255795d8c1a0a82a439cbe2f7715fdb.png";